import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import MuiDialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import * as BaseComponents from './components';

function Dialog({
  actionLabel,
  children,
  components = {},
  disabled,
  footerProps = {},
  fullWidth = true,
  maxWidth = 'md',
  open,
  syncing,
  title,
  subTitle,
  onAction,
  onClose,
  padding,
  paperClass,
  overflowX,
  ...rest
}) {
  const fullScreen = useMediaQuery('@media (max-width: 768px)');
  const paperProps = useMemo(
    () => ({ loading: syncing, className: paperClass ? paperClass : null }),
    [syncing, paperClass]
  );

  const { Content, DialogPaper, Footer, Header } = useMemo(
    () => ({ ...BaseComponents, ...components }),
    [components]
  );

  const contentProps = { padding };
  if (overflowX) {
    contentProps.overflowX = overflowX;
  }

  return (
    <MuiDialog
      fullScreen={fullScreen}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      open={open}
      PaperComponent={DialogPaper}
      PaperProps={paperProps}
      onClose={onClose}
      {...rest}
    >
      {title && <Header title={title} subTitle={subTitle} onClose={onClose} />}
      <Content {...contentProps}>{children}</Content>
      <Footer actionLabel={actionLabel} disabled={disabled} onAction={onAction} {...footerProps} />
    </MuiDialog>
  );
}

Dialog.propTypes = {
  actionLabel: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  components: PropTypes.object,
  disabled: PropTypes.bool,
  footerProps: PropTypes.object,
  fullWidth: PropTypes.bool,
  maxWidth: PropTypes.string,
  open: PropTypes.bool.isRequired,
  syncing: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.string]),
  subTitle: PropTypes.string,
  onAction: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  paperClass: PropTypes.string,
  overflowX: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};

export default Dialog;
